// extracted by mini-css-extract-plugin
export default {"BadgeBeta":"_BadgeBeta--RW4Qn"};